import _implicitStylesheets from "./writeReview.css";
import _implicitScopedStylesheets from "./writeReview.scoped.css?scoped=true";
import _wdsStarRatings from "wds/starRatings";
import _wdsInput from "wds/input";
import _wdsTextarea from "wds/textarea";
import _i18nLink from "i18n/link";
import _wdsMessageBox from "wds/messageBox";
import _wdsButton from "wds/button";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="stars-label label--required${0}"${2}>${"t1"}</span>`;
const stc0 = {
  slotAssignment: "main-content",
  key: 1
};
const stc1 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "large"
  },
  key: 2
};
const stc2 = {
  "review-box": true
};
const stc3 = {
  key: 8
};
const stc4 = {
  "textarea": true
};
const stc5 = {
  classMap: {
    "text-disclaimer": true
  },
  key: 10
};
const stc6 = {
  slotAssignment: "footer",
  key: 13
};
const stc7 = {
  "cancel-button": true
};
const stc8 = {
  "delete-review-button": true
};
const stc9 = {
  "data-testid": "delete-review-btn"
};
const stc10 = {
  "data-testid": "write-review-btn"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6} = $ctx;
  return [api_custom_element("wds-modal", _wdsModal, {
    props: {
      "title": $cmp.writeReviewModalLabels.title,
      "closedFocusTarget": $cmp.closedFocusTarget,
      "autoFocusOff": $cmp.autoFocusOff
    },
    key: 0,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.closeModal))
    }
  }, [api_element("div", stc0, [api_element("div", stc1, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "size": "medium",
      "spaceBetween": "small",
      "labelPosition": "top",
      "value": $cmp.formData.rating,
      "forceShowError": $cmp.forceRatingError,
      "ariaLabel": $cmp.formFields.rating.ariaLabel,
      "ratingLabel": $cmp.ratingText,
      "required": true
    },
    key: 3,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleRating))
    }
  }, [api_element("label", {
    slotAssignment: "label",
    attrs: {
      "for": api_scoped_id("reviewDetails")
    },
    key: 4
  }, [api_static_fragment($fragment1, 6, [api_static_part(1, null, api_dynamic_text($cmp.formFields.rating.label))])])]), api_custom_element("wds-input", _wdsInput, {
    classMap: stc2,
    props: {
      "label": $cmp.formFields.title.label,
      "ariaLabel": $cmp.formFields.title.ariaLabel,
      "value": $cmp.formData.title,
      "forceShowError": $cmp.forceTitleError,
      "placeholder": $cmp.formFields.title.placeholder,
      "maxLength": "194",
      "required": true
    },
    key: 7,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleTitleChange))
    }
  }), api_element("div", stc3, [api_custom_element("wds-textarea", _wdsTextarea, {
    classMap: stc4,
    props: {
      "label": $cmp.formFields.description.label,
      "ariaLabel": $cmp.formFields.description.ariaLabel,
      "value": $cmp.formData.description,
      "subtitle": $cmp.formFields.description.description,
      "forceShowError": $cmp.forceDescriptionError,
      "maxLength": "2000",
      "preventResize": true,
      "required": true
    },
    key: 9,
    on: {
      "change": _m3 || ($ctx._m3 = api_bind($cmp.handleDescriptionChange))
    }
  }), api_element("div", stc5, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.writeReviewModalLabels.reviewDisclaimerText,
      "ariaLabel": $cmp.writeReviewModalLabels.reviewDisclaimerText,
      "target": "_blank"
    },
    key: 11
  }), $cmp.errorMsg ? api_custom_element("wds-message-box", _wdsMessageBox, {
    props: {
      "id": api_scoped_id("error-message"),
      "type": "error",
      "message": $cmp.errorMsg,
      "hideCloseButton": true
    },
    key: 12
  }) : null])])])]), api_element("div", stc6, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc7,
    props: {
      "variant": "secondary",
      "label": $cmp.sharedLabels.cancel
    },
    key: 14,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.closeModal))
    }
  }), $cmp.isEditMode ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc8,
    attrs: stc9,
    props: {
      "theme": "error",
      "disabled": $cmp.isWritingOrDeleting,
      "label": $cmp.sharedLabels.delete
    },
    key: 15,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.deleteReview))
    }
  }) : null, api_custom_element("wds-button", _wdsButton, {
    attrs: stc10,
    props: {
      "disabled": $cmp.isWritingOrDeleting,
      "label": $cmp.submitReviewLabel
    },
    key: 16,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.handleSubmitReview))
    }
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5ip36l86j9e";
tmpl.legacyStylesheetToken = "undefined-_writeReview";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
